// extracted by mini-css-extract-plugin
export default {"container":"LLMIndicator_container__y0PWK","icon":"LLMIndicator_icon__tGeJL","truncate":"LLMIndicator_truncate__KHqxi"};